export const SUGGEST_APP_IDEA_Q = /* GraphQL */ `
  query SuggestAppIdea {
    suggestAppIdea {
      id
      name
      tagline
      description
    }
  }
`;

export const RESPOND_APP_IDEA_M = /* GraphQL */ `
  mutation RespondAppIdea($ideaId: ID!, $status: String!) {
    respondAppIdea(ideaId: $ideaId, status: $status)
  }
`;
